import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Truncate from './Truncate';

class Readmore extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      expanded: false,
      truncated: false,
    };
  }

  handleTruncate = (truncated) => {
    if (this.state.truncated !== truncated) {
      this.setState({ truncated });
    }
  }

  toggleLines = (event) => {
    event.preventDefault();
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { children, lines } = this.props;
    const { expanded, truncated } = this.state;

    return (
      <div className="readmore-container">
        <Truncate
          lines={!expanded && lines}
          ellipsis={(<span>... <button className="readmore-button" type="button" onClick={this.toggleLines}>Read more</button></span>)}
          onTruncate={this.handleTruncate}
        >
          {children}
        </Truncate>
        {!truncated && expanded && (
          <span> <button className="readmore-button less" type="button" onClick={this.toggleLines}>Show less</button></span>
        )}
      </div>
    );
  }
}

Readmore.defaultProps = {
  lines: 4,
};

Readmore.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
};

export default Readmore;



// WEBPACK FOOTER //
// ./src/Components/Paragraph/Readmore.jsx